import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ShopService } from '@services/shop.service';
import { Router } from '@angular/router';
import { BrandName, formatCurrency, getCurrencySymbol } from '@utils/utils';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
// import { User } from '../../models/user';
import { Subscription } from 'rxjs';
import { loadStripe } from '@stripe/stripe-js';
import { PaymentService } from '@services/payment.service';
import { PaymentData } from '@models/payment-method';
declare let paypal: any;
import $ from 'jquery';
import { environment } from '@env';
import { Cart } from '@models/shop/cart';
import { AtlasToastService } from '@services/atlas-toast.service';
import { UserService } from '@services/user.service';
import { LoaderService } from '@services/loader.service';
import { finalize } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { User } from '@models/user';
import { SessionStorageService } from 'ngx-webstorage';

@Component({
  selector: 'wsb-shop-cart',
  templateUrl: './shop-cart.component.html',
  styleUrls: ['./shop-cart.component.scss'],
  standalone: false
})
export class ShopCartComponent implements OnInit, OnDestroy {
  baseUrl = environment.serverBaseUrl;
  modalPaymentMode: NgbModalRef;
  @ViewChild('modalStripePayment') modalStripePayment;
  @ViewChild('modalAcceptTerms') modalAcceptTerms;
  @ViewChild('modalPaymentMethod') modalPaymentMethod;
  @ViewChild('modalBankTransfertPayment') modalBankTransfertPayment;
  paymentMode: 'credit_card' | 'bank_transfert' | 'paypalpro' = 'bank_transfert';
  currentStep = 1;
  cart: Cart;
  formatCurrency = formatCurrency;
  faTrash = faTrash;
  getCurrencySymbol = getCurrencySymbol;
  promoCode;
  getPromoCode = false;
  user: User;
  loadingPayment = false;
  routeStep = { 1: '/shop/cart', 2: '/shop/cart-summary' };
  stripe;
  cardElement;
  paymentMethod;
  forceNewCard = false;
  updateQuantityInProgress = false;
  errorCode = '';
  errorStripe = '';
  checkPrivacy = false;
  checkTerms = false;
  checkClause = false;
  paymentMethodOncart: PaymentData;
  payPalLoaded = false;
  enablePaymentBtn = true;
  showCheckClause = false;
  private userSubscription: Subscription;

  constructor(
    private shopService: ShopService,
    private router: Router,
    private userService: UserService,
    public atlasToastService: AtlasToastService,
    private translateService: TranslateService,
    private paymentService: PaymentService,
    private loaderService: LoaderService,
    private modalService: NgbModal,
    private sessionStorage: SessionStorageService
  ) {}

  ngOnInit(): void {
    this.currentStep = this.router.url.split('?')[0] === '/shop/cart' ? 1 : 2;
    this.loadCart();
    this.userSubscription = this.userService.getAuthenticationState().subscribe(loggedUser => {
      this.user = loggedUser;
    });

    this.loadPaymentMethod();
    this.getPaymentMethodOnCart();
    // this.loadPaymentMethodsGateway();

    this.initPaypal();

    this.paymentService.getStripeKey().subscribe(key => {
      loadStripe(key).then(stripe => {
        this.stripe = stripe;
      });
    });

    switch (this.sessionStorage.retrieve('wsb-brand-name')) {
      case BrandName.SKEBBY:
        this.showCheckClause = true;
        break;
      case BrandName.MOBYT:
        this.showCheckClause = true;
      default:
        break;
    }
  }

  mountCard() {
    const that = this;
    const elements = this.stripe.elements();
    this.cardElement = elements.create('card');
    this.cardElement.mount('#card-element');
    this.cardElement.on('change', () => {
      that.errorStripe = '';
    });
  }
  updateQuantityItem(carItem, quantity) {
    this.updateQuantityInProgress = true;
    this.shopService.updateQuantityCartItem(carItem.shopItem.idShopItem, quantity).subscribe(
      () => {
        // this.atlasToastService.success('common_success', null);
      },
      error => {
        this.atlasToastService.error('common_error', error.error.error_message);
      },
      () => {
        this.updateQuantityInProgress = false;
        this.loadCart();
      }
    );
  }

  getPaymentMethodOnCart() {
    this.paymentService.getPaymentMethodOnCart().subscribe(
      data => {
        this.paymentMethodOncart = data;
        if (this.paymentMethodOncart.cartEnabledPaymentMethods['credit-card']) {
          if (this.paymentMethodOncart?.paymentGateways.indexOf('stripe') > -1) {
            this.paymentMode = 'credit_card';
          } else if (this.paymentMethodOncart?.paymentGateways.indexOf('paypalpro') > -1) {
            this.paymentMode = 'paypalpro';
          }
        }
        this.enablePaymentBtn = this.isEnablePaymentButton();
      },
      () => {
        this.paymentMethod = null;
      }
    );
  }

  lock(paymentMethod) {
    this.shopService.lockCurrentReadyShopCart(paymentMethod).subscribe(
      data => {},
      () => {
        this.router.navigate(['/shop/purchase-error']);
      },
      () => {
        this.loadingPayment = false;
      }
    );
  }

  closeBankTransfer() {
    this.router.navigate(['/shop/purchase-success']);
    this.modalPaymentMode.close();
  }

  forcePaymentNewCard() {
    this.modalPaymentMode.close();
    this.forceNewCard = true;
    this.openModalPayment();
  }

  initPaypal() {
    if (!this.payPalLoaded && this.currentStep === 2) {
      this.payPalLoaded = true;
      const that = this;
      this.paymentService.getPaypalParams().subscribe(params => {
        $.getScript('https://www.paypalobjects.com/api/checkout.js', () => {
          paypal.Button.render(
            {
              env: params['payment-environment'] === 'sandbox' ? params['payment-environment'] : 'production', // sandbox | production
              style: {
                size: 'large',
                color: 'white',
                shape: 'pill',
                label: 'buynow',
                tagline: 'false'
              },
              // Show the buyer a 'Pay Now' button in the checkout flow?
              commit: false,

              // payment() is called when the button is clicked
              payment() {
                // Set up a url on your server to create the payment
                return that.paymentService.paypalCreatePayment(params, that.cart.idShoppingCart).then(response => {
                  return response.paymentId;
                });
              },

              // onAuthorize() is called when the buyer approves the payment
              onAuthorize(data, actions) {
                return actions.payment.get().then(paymentDetails => {
                  // Set up the data you need to pass to your server
                  const dataExec = {
                    paymentId: paymentDetails.id,
                    payerId: paymentDetails.payer.payer_info.payer_id
                    // userNote: "" // TODO: shop_cart_user_note
                  };

                  // Execute the payment
                  that.paymentService.paypalExecutePayment(dataExec).then(response => {
                    that.router.navigate(['/shop/purchase-success']);
                  });
                });
              },

              cancelEvent(data, actions) {
                that.router.navigate(['/shop/purchase-error']);
              },

              onError(error) {
                that.router.navigate(['/shop/purchase-error']);
              }
            },
            '#paypal-button-container'
          );
        });
      });
    }
  }

  private isEnablePaymentButton() {
    return (
      (this.paymentMethodOncart?.paymentGateways.indexOf('paypalpro') > -1 &&
        this.paymentMethodOncart?.cartEnabledPaymentMethods['credit-card']) ||
      (this.paymentMethodOncart?.paymentGateways.indexOf('stripe') > -1 &&
        this.paymentMethodOncart?.cartEnabledPaymentMethods['credit-card']) ||
      (this.paymentMethodOncart?.userEnabledPaymentMethods['bank-transfer'] &&
        this.paymentMethodOncart?.cartEnabledPaymentMethods['bank-transfer'])
    );
  }

  openModalPayment(): void {
    if (this.checkTerms && this.checkPrivacy && (this.checkClause || !this.showCheckClause)) {
      switch (this.paymentMode) {
        case 'credit_card':
          if (this.paymentMethod && !this.forceNewCard) {
            this.modalPaymentMode = this.modalService.open(this.modalPaymentMethod, { size: 'lg', backdrop: 'static', keyboard: false });
          } else {
            this.modalPaymentMode = this.modalService.open(this.modalStripePayment, { backdrop: 'static', keyboard: false });
            this.mountCard();
          }
          this.listenModalPaymentClose(this.modalPaymentMode);
          break;
        case 'paypalpro':
          break;
        case 'bank_transfert':
          // this.lock('bb');
          this.shopService.lockCurrentReadyShopCart('bb').subscribe(
            data => {
              this.modalPaymentMode = this.modalService.open(this.modalBankTransfertPayment, { size: 'lg' });
              this.listenModalPaymentClose(this.modalPaymentMode);
            },
            () => {
              this.router.navigate(['/shop/purchase-error']);
            },
            () => {
              this.loadingPayment = false;
            }
          );
          break;
      }
    } else {
      this.modalPaymentMode = this.modalService.open(this.modalAcceptTerms);
      this.listenModalPaymentClose(this.modalPaymentMode);
    }
  }

  listenModalPaymentClose(modal: NgbModalRef) {
    modal.result.then(
      () => {},
      reason => {
        // closed via x button
        if (!reason && this.paymentMode === 'bank_transfert') {
          this.closeBankTransfer();
        }
        this.forceNewCard = false;
      }
    );
  }
  loadPaymentMethod(): void {
    this.paymentMethod = null;
    this.paymentService.getPaymentMethod().subscribe(
      data => {
        this.paymentMethod = data;
      },
      () => {
        this.paymentMethod = null;
      }
    );
  }

  pay() {
    const that = this;
    this.loadingPayment = true;
    if (this.paymentMethod && !this.forceNewCard) {
      that.createUserPayment(this.paymentMethod.paymentMethodId);
    } else {
      this.stripe
        .createPaymentMethod({
          type: 'card',
          card: this.cardElement
        })
        .then(result => {
          if (result.paymentMethod) {
            that.createUserPayment(result.paymentMethod.id);
          } else {
            that.errorStripe = result.error.message;
            that.loadingPayment = false;
          }
        });
    }
  }

  createUserPayment(paymentmethodId) {
    const that = this;
    that.paymentService.createUserPayment(paymentmethodId, that.cart.idShoppingCart).subscribe(
      result => {
        if (result['require-action'] && result['payment-intent-client-secret']) {
          that.stripe
            .confirmCardPayment(result['payment-intent-client-secret'], {
              payment_method: paymentmethodId
            })
            .then(resultConfirm => {
              if (resultConfirm.paymentIntent && resultConfirm.paymentIntent.status === 'succeeded') {
                that.router.navigate(['/shop/purchase-success']);
              } else if (resultConfirm.error) {
                that.router.navigate(['/shop/purchase-error']);
              }
            });
        } else {
          that.router.navigate(['/shop/purchase-success']);
        }
      },
      error => {
        console.log('ERROR');
        that.router.navigate(['/shop/purchase-error']);
      },
      () => {
        that.modalPaymentMode.close();
        that.loadingPayment = false;
      }
    );
  }

  loadCart() {
    this.loaderService.show();
    this.shopService
      .getCurrentCart()
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe(currentCart => {
        // if (!currentCart.shopCartItems) {
        //   this.router.navigate(['/shop/index']);
        // }
        this.cart = currentCart;
      });
  }

  addPromoCode(e) {
    e.preventDefault();
    this.errorCode = '';
    this.shopService.addPromoCodeToShopCart(this.promoCode).subscribe(
      card => {
        this.cart = card;
      },
      error => {
        this.errorCode = error.error.error_message;
      },
      () => {}
    );
  }

  removeCode() {
    this.shopService.removePromoCodeToShopCart().subscribe(currentCart => {
      this.cart = currentCart;
    });
  }

  removeItem(item) {
    this.shopService.deleteShopCartItem(item.shopItem.idShopItem, item.idUser).subscribe(
      () => {
        this.atlasToastService.success('common_success', null);
      },
      error => {
        this.atlasToastService.error('common_error', error.error.error_message);
      },
      () => {
        this.loadCart();
      }
    );
  }

  printBankDetails() {
    window.print(); // only modal content should get print
    this.closeBankTransfer();
  }

  goToSummary() {
    if (this.cart.shopCartItems) {
      this.router.navigate(['/shop/cart-summary']);
    }
  }

  loadExternalScript(scriptUrl: string) {
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script');
      scriptElement.src = scriptUrl;
      scriptElement.onload = resolve;
      scriptElement.setAttribute('id', 'paypal-script');
      scriptElement.setAttribute('defer', 'true');
      document.body.appendChild(scriptElement);
    });
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }

  displayFraudAlert() {
    return (
      (this.paymentMethodOncart?.paymentGateways.indexOf('paypalpro') == -1 &&
        !this.paymentMethodOncart?.cartEnabledPaymentMethods['credit-card']) ||
      (this.paymentMethodOncart?.paymentGateways.indexOf('stripe') > -1 &&
        !this.paymentMethodOncart?.cartEnabledPaymentMethods['credit-card']) ||
      (this.paymentMethodOncart?.userEnabledPaymentMethods['bank-transfer'] &&
        !this.paymentMethodOncart?.cartEnabledPaymentMethods['bank-transfer'])
    );
  }

  displayFraudAlertV2() {
    return (
      (!this.paymentMethodOncart?.cartEnabledPaymentMethods['credit-card'] ||
        (this.paymentMethodOncart?.paymentGateways.indexOf('stripe') == -1 &&
          this.paymentMethodOncart?.paymentGateways.indexOf('paypalpro') == -1)) &&
      this.paymentMethodOncart?.cartEnabledPaymentMethods['bank-transfer'] &&
      this.paymentMethodOncart?.userEnabledPaymentMethods['bank-transfer']
    );
  }

  replaceLabelTagWithValue(cartItem) {
    let label: string = this.translateService.instant(cartItem.shopItem.label);

    const splitChart = this.user.nation === 'gbr' ? '.' : ',';

    label = label.replace('$1$', cartItem?.serviceParams?.ratedSms);
    label = label.replace('$2$', (cartItem.shopItem.price as string).split(splitChart)[0]);

    return label;
  }

  havePromoCode(event) {
    event.preventDefault();
    this.getPromoCode = !this.getPromoCode;
  }
}
